<template>
  <div id="blog-main" :key="'blog-main'">
    <a-list :dataSource="list" :loading="loading" :pagination="pagination" itemLayout="vertical">
      <template slot="header">
        <h3>文章列表</h3>
      </template>
      <a-list-item slot="renderItem" slot-scope="item" :key="item.title">
        <a-descriptions size="small">
          <template slot="title">
            <router-link
              :to="{ name: 'post', params: { id: item.id,from:{name:'list'} }}"
              class="article-title"
            >{{item.title}}</router-link>
            <span style="float:right">
              <a-tag v-if="item.isOriginal" color="blue">原创</a-tag>
              <a-tag v-else>转载</a-tag>
            </span>
          </template>
          <a-descriptions-item label="创建时间">{{item.createTime}}</a-descriptions-item>
          <a-descriptions-item label="更新时间">{{item.updateTime}}</a-descriptions-item>
          <a-descriptions-item label="浏览量">{{item.views}}</a-descriptions-item>
        </a-descriptions>
        <span v-html="item.introduce" class="markdown content"></span>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import { mapState } from "vuex";
import serverPath from "../serverPath";
import Toc from "../utils/Toc.js";
const PAGESIZE = 10;
export default {
  name: "blog-main",
  data() {
    return {
      list: [],
      loading: {
        size: "large",
        tip: "加载和解析markedown中……",
        indicator: <a-icon type="loading" style="font-size: 24px" spin />
      }
    };
  },
  computed: {
    ...mapState(["articleTotal"]),
    pagination() {
      return {
        pageSize: PAGESIZE,
        total: this.articleTotal || 0,
        onChange: (currentPage, pageSize) => {
          this.getList(currentPage, pageSize);
        }
      };
    }
  },
  methods: {
    getList(currentPage = 1, pageSize = PAGESIZE) {
      this.axios({
        url: serverPath.getBlogList,
        methods: "get",
        params: {
          currentPage: currentPage,
          pageSize: pageSize
        }
      })
        .then(res => {
          if (res.status === 200) {
            this.list = res.data.content;
            this.list.map(item => {
              item.introduce = Toc.mdToHtml(item.introduce || "");
            });
            this.$store.commit("setArticleTotal", res.data.articleTotal);
            this.$store.commit("setTotal", res.data.total);
            this.loading = false;
          } else {
            this.$message.error(
              "数据获取失败，错误代码：" + res.stratus + "," + res.statusText
            );
          }
        })
        .catch(e => {
          this.$notification["error"]({
            message: "数据获取失败",
            description: e.toString(),
            duration: 0,
            placement: "topLeft",
            style: {
              marginTop: "2rem"
            }
          });
        });
    }
  },
  beforeMount() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
// #blog-main {
//   margin-left: 0.5rem;
//   padding: 1rem;
// }
.article-title {
  font-size: 1.3rem;
}
.content {
  word-break: break-all;
}
</style>